var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-3"},[_c('h4',{staticClass:"text-center mb-4"},[_vm._v("ESTADOS PMI")]),_c('CChartDoughnut',{attrs:{"datasets":_vm.defaultDatasets,"labels":['Aceptado', 'Devueltos', 'En Revisión','En Proceso']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }